import { getTabCustomerId } from "@common/api/apiShared";

export function createPdfUrl(url: string, language: string) {
    if (url.includes("?")) url += "&";
    else url += "?";

    return encodeURIComponent(url + `customerId=${getTabCustomerId()}&lang=${language}`);
}

export function isPdfRequest() {
    return !!getPdfToken();
}

export function getPdfToken() {
    return new URLSearchParams(window.location.search).get("pdfToken");
}
